<template>
    <v-dialog
        v-model="$store.state.paperworkAnalytics.DailySummay"
        fullscreen
        persistent
        transition="dialog-transition"
    >
        <v-toolbar dense dark color="secondary" class="white--text">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Order Data Viewer
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                left
                @click="$store.state.paperworkAnalytics.DailySummay = false"
            >
                <v-icon>
                    mdi-window-close
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-card style="height: 80vh; background-color: #fff;">
            <v-container fluid>
                <div style="height: 50vh; background-color: #fff;">
                    <div>
                        <v-toolbar
                            dense
                            dark
                            flat
                            height="35"
                            color="secondary"
                            class="white--text"
                        >
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                Document Daily Summary
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-row>
                            <v-col cols="12">
                                <v-data-iterator
                                    :items="OrderToCheck[0].document"
                                    :page="page"
                                    :items-per-page="1"
                                    hide-default-footer
                                >
                                    <template v-slot:default="props2">
                                        <v-container
                                            v-for="(it, id) in props2.items"
                                            v-bind:key="'document' + id"
                                            style="background-color: #fff;"
                                            fluid
                                        >
                                            <iframe
                                                :src="it.Link"
                                                style="width: 100%; height:80vh ;"
                                            ></iframe>

                                            <v-pagination
                                                v-model="page"
                                                :length="
                                                    OrderToCheck[0].document
                                                        .length
                                                "
                                                prev-icon="mdi-menu-left"
                                                next-icon="mdi-menu-right"
                                            ></v-pagination>
                                        </v-container>
                                    </template>
                                </v-data-iterator>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-container>
            <action
                v-if="$store.state.paperworkAnalytics.action"
                :OrderID="OrderID"
                :Actions="actions"
                :BolCheckStatus="BolCheckStatus"
                :Ord="OrderToCheck"
            ></action>
        </v-card>
    </v-dialog>
</template>

<script>
// Imports here
import axios from 'axios';
import action from './ActionReason.vue';

export default {
    props: ['OrderToCheck', 'FromEleosCheck', 'actions', 'Shift'],
    components: {
        action
    },
    data: function() {
        return {
            page: 1,
            pagination: 0
        };
    },
    mounted() {
        //this.functionsForMountedHere();
        // this.pagination = this.OrderToCheck.document.length;
        console.log(this.Shift);
    },
    methods: {
        /*functionHere: function() {

        },
        otherFunctionHere: function() {

        }
        */
        sendToVerifiedOrders: async function(orderID) {
            var str = this.$store;
            console.log('sendToVerifiedOrders');
            console.log(orderID);
            var parms = {
                BolCheckStatusID: 1
            };
            this.$store.state.isLoading = true;
            await axios
                .put('order/' + orderID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });

                    this.OrderToCheck.Status = 'success';
                    this.OrderToCheck.BolCheckStatusID = this.BolCheckStatus;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        openActionReasonModal: function(orderID, BolCheckStatus) {
            this.BolCheckStatus = BolCheckStatus;
            this.OrderID = orderID;
            this.$store.state.paperworkAnalytics.action = true;
        }
    }
};
</script>

<style>
/* Styles here */
</style>
